const BotTableRenderer = ({ tableData }) => {
    if (!Array.isArray(tableData) || tableData.length === 0) return null;

    const headers = Object.keys(tableData[0]);

    return (
        <table className="w-full mt-2 border text-sm">
            <thead>
                <tr>
                    {headers.map((head) => (
                        <th
                            key={head}
                            className="border px-2 py-1 bg-gray-200 dark:bg-[#232323]"
                        >
                            {head}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {tableData.map((row, i) => (
                    <tr key={i}>
                        {headers.map((head) => (
                            <td key={head} className="border px-2 py-1">
                                {row[head]}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default BotTableRenderer;

